module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/title_boxing_club-a9ddc65fbc7fb26bc78caebaf0f4d91e.png";